// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

//window.jQuery = window.$ = require('vendors/public/jquery-3.6.0.min.js');
//require('vendors/public/jquery-migrate-3.3.0.min.js');

// Bootstrap - The most popular framework that Metronic uses as the foundation. Learn more: http://getbootstrap.com
//require('bootstrap');
require('vendors/public/bootstrap.bundle.min.js');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('popper.js').default;

// Typeahead.js - a flexible JavaScript library that provides a strong foundation for building robust typeaheads: https://twitter.github.io/typeahead.js/
window.typeahead = require('typeahead.js');
window.Bloodhound = require('typeahead.js/dist/bloodhound.min.js');

window.tagsinput = require('bootstrap-tagsinput');

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.min.js');
require('vendors/private/plugins/sweetalert2.init.js');

require("sharer.js")

// Selectize.js
require('selectize/dist/js/selectize.js');

// Plugins
require('vendors/public/plugins/waypoints.js');
window.WOW = require('vendors/public/plugins/wow.js').WOW;
require('vendors/public/plugins/magnific-popup.js');
window.PerfectScrollbar = require('vendors/public/plugins/perfect-scrollbar.min.js');

//window.select2 = require('vendors/public/plugins/select2.min.js');
require('vendors/public/plugins/isotope.js');
require('vendors/public/plugins/scrollup.js');
window.Swiper = require('vendors/public/plugins/swiper-bundle.min.js');